import { SettingsRoutes } from "routes/settings/constants";
import { INavigationItem } from "routes/settings/navigation/interfaces";

import { SettingsNavigationGroup } from "./interfaces";
import { SettingsSection } from "./sections";

export const NAVIGATION_GROUPS = Object.values(SettingsNavigationGroup);
export const NAVIGATION_ITEMS: INavigationItem[] = [
  {
    name: "Email",
    path: SettingsRoutes.EmailAddress,
    section: SettingsSection.EmailAddresses,
    group: SettingsNavigationGroup.Channels,
  },
  {
    name: "Contact forms",
    path: SettingsRoutes.ContactForms,
    section: SettingsSection.ContactForms,
    group: SettingsNavigationGroup.Channels,
  },
  {
    name: "Contact widget",
    path: SettingsRoutes.OpenWidget,
    section: SettingsSection.OpenWidget,
    group: SettingsNavigationGroup.Channels,
  },
  {
    name: "LiveChat",
    path: SettingsRoutes.LiveChat,
    section: SettingsSection.LiveChat,
    group: SettingsNavigationGroup.Channels,
  },
  {
    name: "Canned responses",
    path: SettingsRoutes.CannedResponses,
    section: SettingsSection.CannedResponses,
    group: SettingsNavigationGroup.Ticketing,
  },
  {
    name: "Tags",
    path: SettingsRoutes.Tags,
    section: SettingsSection.Tags,
    group: SettingsNavigationGroup.Ticketing,
  },
  {
    name: "Ticket views",
    path: SettingsRoutes.MyViews,
    section: SettingsSection.MyViews,
    group: SettingsNavigationGroup.Customization,
  },
  {
    name: "Custom fields",
    path: SettingsRoutes.CustomFields,
    section: SettingsSection.CustomFields,
    group: SettingsNavigationGroup.Customization,
  },
  {
    name: "Email templates",
    path: SettingsRoutes.EmailTemplates,
    section: SettingsSection.EmailTemplates,
    group: SettingsNavigationGroup.Customization,
  },
  {
    name: "Email notifications",
    path: SettingsRoutes.Notifications,
    section: SettingsSection.Notifications,
    group: SettingsNavigationGroup.Preferences,
  },
  {
    name: "Spam",
    path: SettingsRoutes.Spam,
    section: SettingsSection.Spam,
    group: SettingsNavigationGroup.Preferences,
  },
  {
    name: "Apps and integrations",
    path: SettingsRoutes.Integrations,
    section: SettingsSection.Integrations,
    group: SettingsNavigationGroup.Toolset,
  },
  {
    name: "API and webhooks",
    externalUrl: "https://api.helpdesk.com/docs",
    section: SettingsSection.API,
    group: SettingsNavigationGroup.Toolset,
  },
];
